import * as api from '../../services/invitationTpl'

export const FETCH_INVITATION_TPLS = 'FETCH_INVITATION_TPLS';
export const FETCH_INVITATION_TPL = 'FETCH_INVITATION_TPL';


export const fetchInvitationTpl = (id) => ({
    type: FETCH_INVITATION_TPL,
    payload: {
        promise: api.findInvitationTpl({id: id})
    }
});


export const fetchInvitationTpls = (params, pagination, sort, extra) => {

    return {
        type: FETCH_INVITATION_TPLS,
        payload: {
            promise: api.findInvitationTpls(Object.assign({}, params)),
        },
        meta: {
            searchParams: params,
            extra: extra
        }
    };
};



// WEBPACK FOOTER //
// ./src/redux/actions/invitationTpl.js